// src/components/MonthlyEarnings.jsx
import React, { useEffect, useMemo, useState } from "react"
import { Card, CardBody, Row, CardTitle } from "reactstrap"
import DonutChart from "./DonutChart"
import "c3/c3.css"

import { useSelector } from "react-redux"
import config from "config/config"
import axios from "axios"
import "../../newcomponents/index.css"

const MonthlyEarnings = props => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const userData = useSelector(state => state.Login.userData)

  const [doctors, setDoctors] = useState([])
  const [reviews, setReviews] = useState([])

  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const token = userData?.token

  const authHeaders = useMemo(
    () =>
      token
        ? {
            headers: { Authorization: `Bearer ${token}` },
          }
        : null,
    [token],
  )

  const fetchReviews = async () => {
    if (!authHeaders) return
    try {
      const { data } = await axios.get(
        `${config.backendUrl}/healthgrade/getReviews?integrationId=${
          isConsolidatedView
            ? organizations
                .map(org => org.Organization.HealthgradeIntegrations[0].id)
                .join(",")
            : activeOrganization.HealthgradeIntegrations[0].id
        }`,
        authHeaders,
      )
      setReviews(Array.isArray(data?.reviews) ? data.reviews : [])
    } catch (err) {
      // why: surface backend/network failure to UI
      props?.setErr?.("Error fetching reviews.")
    }
  }

  const fetchDoctors = async () => {
    if (!authHeaders) return
    try {
      const { data } = await axios.get(
        `${config.backendUrl}/healthgrade/getDoctors?integrationId=${
          isConsolidatedView
            ? organizations
                .map(org => org.Organization.HealthgradeIntegrations[0].id)
                .join(",")
            : activeOrganization.HealthgradeIntegrations[0].id
        }`,
        authHeaders,
      )
      setDoctors(Array.isArray(data?.doctors) ? data.doctors : [])
    } catch (err) {
      // why: correct message for doctors endpoint
      props?.setErr?.("Error fetching doctors.")
    }
  }

  useEffect(() => {
    if (!authHeaders) return // parallel fetch to reduce latency
    ;(async () => {
      await Promise.allSettled([fetchDoctors(), fetchReviews()])
    })()
  }, [authHeaders, isConsolidatedView, activeOrganization, organizations])

  const reviewCounts = useMemo(() => {
    const counts = Object.create(null)
    for (const r of reviews || []) {
      const name = r?.reviewsFor
      if (!name) continue
      counts[name] = (counts[name] || 0) + 1
    }
    return counts
  }, [reviews])

  const topRatedDoctor = useMemo(() => {
    if (!doctors?.length) return null
    let best = null
    let bestRating = -Infinity
    let bestCount = -Infinity

    for (const doc of doctors) {
      const name = doc?.doctorName || ""
      const ratingRaw = doc?.rating
      const rating =
        typeof ratingRaw === "number"
          ? ratingRaw
          : Number.parseFloat(ratingRaw) || 0

      // prefer reviews-derived count; fallback to doc.reviewCount if provided
      const count =
        (name && reviewCounts[name]) ??
        (typeof doc?.reviewCount === "number" ? doc.reviewCount : 0)

      if (
        rating > bestRating ||
        (rating === bestRating && count > bestCount) ||
        (rating === bestRating &&
          count === bestCount &&
          best &&
          String(name).localeCompare(String(best.doctorName)) < 0)
      ) {
        best = doc
        bestRating = rating
        bestCount = count
      }
    }
    return best
  }, [
    doctors,
    reviewCounts,
    activeOrganization,
    isConsolidatedView,
    organizations,
  ])
  console.log("Top rated doctor:", topRatedDoctor)
  return (
    <React.Fragment>
      <Card className="br">
        <CardBody>
          <CardTitle className="h4 mb-4">Doctors Rating</CardTitle>

          <Row className="text-center mt-4">
            <div className="col-12">
              <h5 className="font-size-20">
                {topRatedDoctor?.doctorName || "—"}
              </h5>
              <p className="text-muted mb-1">Top Rated Doctor</p>
              {/* {topRatedDoctor ? (
                <div className="small text-muted">
                  Rating: {Number(topRatedDoctor.rating || 0).toFixed(1)}
                  {(() => {
                    const name = topRatedDoctor.doctorName
                    const rc =
                      (name && reviewCounts[name]) ??
                      (typeof topRatedDoctor?.reviewCount === "number"
                        ? topRatedDoctor.reviewCount
                        : 0)
                    return rc ? ` · ${rc} review${rc === 1 ? "" : "s"}` : ""
                  })()}
                </div>
              ) : null} */}
            </div>
          </Row>

          <div dir="ltr">
            <DonutChart
              rating={Number(topRatedDoctor?.rating || 0)}
              style={{
                color: "#2990DF",
              }}
            />
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonthlyEarnings
